import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import { stylefunction } from 'ol-mapbox-style'

import PoziAPIData from 'api/data'
import * as PoziUtils from 'api/utils'
import GeoJSONIO from 'data/geojsonio'

export const MAPBOX_STYLE_NOT_COMPATABLE = 'MAPBOX_STYLE_NOT_COMPATABLE'
export const NO_MAPBOX_STYLE_FOUND = 'NO_MAPBOX_STYLE_FOUND'
export const MAPBOX_STYLE_APPLIED = 'MAPBOX_STYLE_APPLIED'

export default function (layer) {
  return new Promise(function (resolve, reject) {
    const mapboxStyleURL = get(layer, 'style.mapbox', null)
    if (isNil(mapboxStyleURL)) {
      return resolve(NO_MAPBOX_STYLE_FOUND)
    }
    console.log('Apply mapbox style')
    PoziAPIData().ajax({
      url: mapboxStyleURL,
      error: function (jqXHR, textStatus, errorThrown) {
        return resolve(NO_MAPBOX_STYLE_FOUND)
      },
      success: function (glStyle, textStatus, jqXHR) {
        const glStyleVersion = get(glStyle, 'version', null)
        if (isNil(glStyleVersion)) {
          return resolve(NO_MAPBOX_STYLE_FOUND)
        }
        setStyle(glStyle, layer, resolve)
      }
    })
  })
}

function setStyle (glStyle, layer, resolve) {
  const olLayer = PoziUtils.getOpenLayersObjectFromTitleID(layer.titleid)

  let url = get(layer, 'config.spatial.url', '')
  if (url === '') {
    console.log('Invalid URL defined for VectorLayer!', layer.title)
    return
  }

  // feature property to act as identifier
  const featureId = get(layer, 'config.spatial.id', '')
  if (featureId === '') {
    console.log('ID not defined for VectorLayer!', layer.title)
    return
  }

  console.log('mapboxStyle loaded', layer.titleid)
  // https://github.com/openlayers/ol-mapbox-style
  // How to detect the source name? Is this even necessary?
  // The first style in the mapbox layers array often seems to be 'background', which does not have a source element.
  // Get the first valid source name?
  const glStyleLayers = get(glStyle, 'layers', [])
  const glStyleSources = get(glStyle, 'sources', [])
  let layerid = ''
  const layerids = []
  let sourceURL = ''
  for (const key in glStyleSources) {
    if (Object.prototype.hasOwnProperty.call(glStyleSources, key)) {
      let source = ''
      if (has(glStyleSources[key], 'url')) {
        source = glStyleSources[key].url.replace('mapbox://', '')
      }
      if (sourceURL !== '') {
        sourceURL += ','
      }
      sourceURL += source
    }
  }
  url = url.replace('{sources}', sourceURL)

  for (let j = 0; j < glStyleLayers.length; j++) {
    const styleLayer = glStyleLayers[j]
    // sourceName = get(styleLayer, 'source-layer', '')
    if (has(styleLayer, 'source')) {
      layerid = get(styleLayer, 'id', '')
      layerids.push(layerid)
    }
  }

  // stylefunction returns a function with signature f(feature, resolution)
  // olStyleFunction(f,r) returns an array of olStyle objects.
  let olStyleFunction = null
  if (get(glStyle, 'version', null)) {
    olStyleFunction = stylefunction(olLayer, glStyle, layerids)
  }
  const olStyleFunctionWithSelection = function (feature, resolution) {
    let stylesMB = []
    if (olStyleFunction) {
      stylesMB = olStyleFunction(feature, resolution) || [] // array of olStyle
    }
    let styles = [] // Selected styles
    // See ./map/SelectVectorFeature - Triggers a style refresh with: olLayer.setStyle(olLayer.getStyle())
    const state = window.store.getState()
    // console.log('olStyleFunctionWithSelection get currentTarget from state')
    const currentTarget = get(state, 'currentTarget', null)
    const titleid = get(currentTarget, 'titleid', '')
    const layer = PoziUtils.getLayerFromTitleID(titleid)
    let compareValue = ''
    if (currentTarget?.propertiesId) {
      compareValue = currentTarget.propertiesId
    }
    const featureIdValue = PoziUtils.getFeaturePropertyValueCaseInsensitive(feature, featureId)
    if (currentTarget && layer && layer.selected && currentTarget.titleid === layer.titleid && compareValue !== '' && featureIdValue === compareValue) {
      // console.log('Set style to selected', layer.titleid, featureIdValue)
      const styleSelected = GeoJSONIO().getStyle(layer, feature, resolution, true)
      styles = [...styles, ...styleSelected]
    } else if (stylesMB.length === 0) {
      // console.log('Set style to unselected', layer.titleid, featureIdValue)
      const styleUnselected = GeoJSONIO().getStyle(layer, feature, resolution, false)
      styles = [...styles, ...styleUnselected]
    } else {
      // Style should be set to whatever is defined in the mapbox style.
    }
    const allStyles = [...styles, ...stylesMB] // Combine two arrays ES5
    return allStyles
  }

  olLayer.setStyle(olStyleFunctionWithSelection)
  return resolve(MAPBOX_STYLE_APPLIED)
}
